import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'

import { ReactComponent as SchoolIcon } from '../assets/icons/school-icon.svg'
import { ReactComponent as FoldIcon } from '../assets/icons/fold-icon.svg'
import { ReactComponent as UnfoldIcon } from '../assets/icons/unfold-icon.svg'
import ProfileImg from '../assets/images/sidebar-profile.png'
import { menuList } from '../assets/data'

export default function SideBar() {
  const location = useLocation()
  const currentPath = '/' + location.pathname.split('/')[1]
  //console.log(currentPath)
  const [isSideBarFold, setIsSideBarFold] = useState(false)

  return (
    <div className='hidden lg:block'>
      <div
        className={`relative z-30 flex h-full flex-col items-start justify-between bg-static-white shadow-emphasize transition-all duration-150 ${
          isSideBarFold ? 'w-60' : 'w-[240px]'
        }`}
      >
        <div className='flex w-full flex-col'>
          <div className='flex w-full items-center justify-between px-20 py-32'>
            <div className='flex select-none items-center gap-4'>
              <SchoolIcon className='my-[5px]' />
              {!isSideBarFold && (
                <p className='font-poppins text-[20px] font-medium leading-[30px] text-primary-normal'>
                  KlassMate
                </p>
              )}
            </div>
            {!isSideBarFold && (
              <button onClick={() => setIsSideBarFold((prev) => !prev)}>
                <FoldIcon />
              </button>
            )}
          </div>
          <div className='flex w-full flex-col items-start gap-4'>
            {menuList.map((menuItem, index) => (
              <Link
                key={index}
                to={menuItem.path}
                className={`${
                  menuItem.path === currentPath
                    ? 'border-l-[3px] bg-background-secondary pl-[17px]'
                    : 'border-l-0 bg-background-default pl-20'
                } box-border flex w-full items-center gap-12 border-solid border-primary-normal py-[14px] pr-20`}
              >
                <i
                  className={`${
                    menuItem.path === currentPath ? 'fill-primary-normal' : 'fill-label-sub'
                  }`}
                >
                  {menuItem.icon()}
                </i>
                {!isSideBarFold && (
                  <p
                    className={`shrink-0 select-none text-body2-medium ${
                      menuItem.path === currentPath ? 'text-label-default' : 'text-label-info'
                    }`}
                  >
                    {menuItem.title}
                  </p>
                )}
              </Link>
            ))}
          </div>
        </div>
        <div className='py-16'>
          <div className={`flex items-center gap-8 py-8 ${isSideBarFold ? 'px-10' : 'px-20'}`}>
            <img src={ProfileImg} alt='' className='h-40 w-40 shrink-0' />
            {!isSideBarFold && (
              <div className='flex shrink-0 flex-col items-start gap-2'>
                <p className='text-body1-semibold text-label-strong'>홍길동 선생님</p>
                <p className='text-body3-medium text-label-sub'>국어 교과</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        onClick={() => setIsSideBarFold((prev) => !prev)}
        className='absolute left-60 top-0 z-20 flex h-[84px] w-32 cursor-pointer flex-col justify-center rounded-r-[30px] bg-static-white shadow-normal'
      >
        <UnfoldIcon />
      </div>
    </div>
  )
}
